import { SecuredClient } from 'Core/Api/SecuredClient';
import {
    Account,
    AccountFilterRequest,
    GetSharePoolsByOfferingIdQueryRequest,
    IWebApplicationModel,
    OrderBy,
    SlimOffering,
    GetOfferingsByFilterForCustomerQueryRequest,
    GetOfferingsByIdForCustomerQueryRequest,
    IGetOfferingsViewModelByIdForCustomerQueryRequest,
    GetOfferingsViewModelByIdForCustomerQueryRequest,
    SlimApplication,
    GetApplicationsByFilterForCustomerQueryRequest,
    Filter,
    GetApplicationByIdForCustomerQueryRequest,
    CancelApplicationCommandRequest,
} from 'Core/Api/Api';
import Utility from 'Core/Utility';
import ITableDataFetcher from 'components/Forms/DataGrid/SimpleTable/Models/ITableDataFetcher';
import TableRequest from 'Core/TableUtility/Models/TableRequest';
import ITableDataResponse from 'components/Forms/DataGrid/SimpleTable/Models/ITableDataResponse';

export class ClientApplicationHandler implements ITableDataFetcher<SlimApplication> {

    props: any;
    constructor(props) {
        this.props = props;
    }

    GetData(tableRequest: TableRequest): Promise<ITableDataResponse<SlimApplication>> {
        return this.GetApplications(tableRequest);
    }

    GetOfferingViewModelById(request: IGetOfferingsViewModelByIdForCustomerQueryRequest) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const offeringRequest = new GetOfferingsViewModelByIdForCustomerQueryRequest(request);
        return client.getOfferingsViewModelByIdForCustomer(offeringRequest);
    }

    GetAccounts() {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new AccountFilterRequest();
        request.amountPerPage = 500;
        request.orderBy = [];
        request.orderBy.push(new OrderBy({ field: 'Name', ascending: true }));

        return client.getAccounts(request);
    }

    GetApplications(tableRequest: TableRequest) {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new GetApplicationsByFilterForCustomerQueryRequest(tableRequest);
        //request.amountPerPage = 10;
        request.filters = tableRequest?.filters?.map(x =>
            new Filter(x)
        );
        //request.orderBy = [];
        //request.orderBy.push(new OrderBy({ field: 'Name', ascending: true }));

        return client.getApplicationsByFilterForCustomer(request);
    }

    GetApplicationById(id: string | undefined) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const request = new GetApplicationByIdForCustomerQueryRequest();
        request.id = id;

        return client.getApplicationByIdForCustomer(request);
    }

    CancelApplication(id: string | undefined) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const request = new CancelApplicationCommandRequest();
        request.applicationId = id;

        return client.cancelApplication(request);
    }

 
    CreateOfferingApplication(request: IWebApplicationModel) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const requestAsFormData = Utility.ConvertToFormData(request);
        return client.processSubscription(requestAsFormData as any);
    }
}
